export default "__VITE_ASSET__afdbd7d7__"